module.exports = __webpack_public_path__ + "static/media/knowverse.cee29891.png";